import { useTheme } from 'next-themes'
import { Toaster as Sonner, toast } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

function Toaster({ ...props }: ToasterProps) {
    const { theme = 'system' } = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            className="toaster group"
            toastOptions={{
                classNames: {
                    toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
                    description: 'group-[.toast]:text-muted-foreground',
                    actionButton:
                        'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
                    loading:
                        'group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-l-4 group-[.toaster]:border-l-info',
                    cancelButton:
                        'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
                    success:
                        'group-[.toaster]:bg-success/10 group-[.toaster]:text-foreground group-[.toaster]:border-l-4 group-[.toaster]:border-l-success',
                    error: 'group-[.toaster]:bg-destructive/10 group-[.toaster]:text-foreground group-[.toaster]:border-l-4 group-[.toaster]:border-l-destructive',
                    warning:
                        'group-[.toaster]:bg-warning/10 group-[.toaster]:text-foreground group-[.toaster]:border-l-4 group-[.toaster]:border-l-warning',
                    info: 'group-[.toaster]:bg-info/10 group-[.toaster]:text-foreground group-[.toaster]:border-l-4 group-[.toaster]:border-l-info',
                },
            }}
            {...props}
        />
    )
}

export { Toaster, toast }
